import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { RadarChart } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';

export default function FeedbackRadarChart(props: { request: graphql.FeedbackRequest }) {
	const { t } = useTranslation();
	const managerIDs = new Set(props.request.user.managers.map((role) => role.source.id));

	const responses = props.request.responses.edges
		.map(({ node }) => node)
		.filter((response) => response.status === graphql.FeedbackResponseStatus.Shared);
	const [internal, external] = _.partition(responses, (response) => 'id' in response.recipient);
	const [me, colleaguesAndManagers] = _.partition(
		internal,
		(response) => 'id' in response.recipient && response.recipient.id === props.request.user.id,
	);
	const [managers, colleagues] = _.partition(
		colleaguesAndManagers,
		(response) => 'id' in response.recipient && managerIDs.has(response.recipient.id),
	);

	function score(responses: graphql.FeedbackResponse[]): number {
		const scores = responses.flatMap((response) =>
			(response.answers ?? []).flatMap((answer) =>
				typeof answer.stars === 'number' ? [answer.stars] : [],
			),
		);

		if (scores.length === 0) {
			return 0;
		} else {
			return _.mean(scores);
		}
	}

	const scores = [score(me), score(managers), score(colleagues), score(external)];
	return (
		<RadarChart
			labels={[
				t('feedback.radar.label.yourself'),
				t('feedback.radar.label.manager'),
				t('feedback.radar.label.peer'),
				t('feedback.radar.label.external'),
			]}
			scores={scores}
		/>
	);
}

function FeedbackRadarChartSkeleton() {
	return <RadarChart.Skeleton />;
}

FeedbackRadarChart.Skeleton = FeedbackRadarChartSkeleton;
